import React from 'react';
import { get, flowRight as compose } from 'lodash';
import { PropTypes } from 'prop-types';
import { Modal, Spinner } from '@custom-components';
import { Content, SpinnerWrapper } from './styles';
import ErrorModal from '../../Buildings/ErrorModal/ErrorModal';
import { logoColor1, colorWhite } from '../../css/colors';
import withAuth from '../../../hocs/withAuth';

function ResponseModal(props) {
  const { closeModal, response, openModal } = props;
  const message = get(response, 'message.data.AdminMutations.changePropertySupplier.message', null);
  const error = get(response, 'error.message', null);
  if (!error && !message)
    return (
      <Content>
        <Modal smallModal openModal={openModal} showClose={false} title="Please wait...">
          <SpinnerWrapper>
            <Spinner thickness={4} size={36} />
          </SpinnerWrapper>
        </Modal>
      </Content>
    );
  return (
    <ErrorModal
      openModal={openModal}
      errorIcon={!error ? <span>&#10003;</span> : undefined}
      iconColor={colorWhite}
      headerColor={logoColor1}
      titleColor={colorWhite}
      title={error ? 'Oops,' : 'SUCCESS!'}
      subtitle={error ? 'Something went Wrong!' : undefined}
      content={error || message}
      actions={[
        {
          label: 'Okay',
          onClick: closeModal,
          btnTheme: 'secondary'
        }
      ]}
    />
  );
}

ResponseModal.propTypes = {
  response: PropTypes.shape({
    message: PropTypes.node,
    error: PropTypes.node
  }).isRequired,
  closeModal: PropTypes.func.isRequired,
  openModal: PropTypes.bool.isRequired
};
export default compose(withAuth())(ResponseModal);
